import React from "react"
import Img from "gatsby-image"

const ReviewItem = (props) => (
    <div className="review__item" onClick={() => props.modalOpen(<Img fluid={props.images.src.childImageSharp.fluid} alt={props.images.alt} />, 'black')}>
        <Img fluid={props.images.src.childImageSharp.fluid} alt={props.images.alt} />
    </div>
)

export default ReviewItem